"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const api_1 = require("@/api");
function default_1(prop) {
    const dateFormat = (date) => {
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month >= 10 ? month : '0' + month;
        day = day >= 10 ? day : '0' + day;
        return date.getFullYear() + '-' + month + '-' + day;
    };
    const [fondeeDayArr, setFondeeDayArr] = (0, react_1.useState)([]);
    const [isFondeeDayLoaded, setIsFondeeDayLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if ((prop === null || prop === void 0 ? void 0 : prop.dependency) === undefined || (prop === null || prop === void 0 ? void 0 : prop.dependency) === true) {
            const ONE_MIN = 60000; // ? ms
            const ONE_HOUR = 60 * ONE_MIN; // ? ms
            const ONE_DAY = 24 * ONE_HOUR; // ? ms
            const plusDay = (n) => n * ONE_DAY; // ? ms
            const today = new Date();
            const koreaTimeDiff = 9 * ONE_HOUR; // 한국 시간은 UTC보다 9시간 빠름(9시간의 밀리세컨드 표현)
            const utcNow = today.getTime() + today.getTimezoneOffset() * 60 * 1000;
            const startTimestamp = (prop === null || prop === void 0 ? void 0 : prop.altStartDate)
                ? new Date(prop.altStartDate).getTime()
                : utcNow + koreaTimeDiff;
            const endTimestamp = ((prop === null || prop === void 0 ? void 0 : prop.altEndDate) ? new Date(prop.altEndDate).getTime() : startTimestamp) + plusDay(30);
            const startDate = dateFormat(new Date(startTimestamp));
            const endDate = dateFormat(new Date(endTimestamp));
            const timeDiff = endTimestamp - startTimestamp;
            const termInDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
            //공휴일 api
            (0, api_1.getData)(`/api/v1/fondee/holiday-events?end_date=${endDate}&start_date=${startDate}`)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let dayArr = [];
                let holidayArr = [];
                if (((_a = res.data.meta) === null || _a === void 0 ? void 0 : _a.alert_type) === 20000) {
                    holidayArr = res.data.result;
                    // ? 기간이 정해지지 않음: 오늘 ~ 오늘+30일 내에 토요일(6) / 일요일(0) 제외한 날들(정상영업일)을 isBusinessDays에 추가
                    // ! 기간이 정해짐: altStartDate ~ altEndDate 내에 토요일(6) / 일요일(0) 제외한 날들(정상영업일)을 isBusinessDays에 추가
                    for (let i = 0; i < termInDays; i++) {
                        const dateTimestamp = startTimestamp + plusDay(i);
                        if (new Date(dateTimestamp).getDay() !== 6 &&
                            new Date(dateTimestamp).getDay() !== 0) {
                            dayArr.push(dateFormat(new Date(dateTimestamp)));
                        }
                    }
                    const businessDayArr = dayArr.filter(day => !holidayArr.includes(day));
                    setFondeeDayArr(businessDayArr);
                }
            }))
                .catch(() => { })
                .finally(() => setIsFondeeDayLoaded(true));
        }
    }, [prop === null || prop === void 0 ? void 0 : prop.dependency]);
    return { isFondeeDayLoaded, fondeeDayArr };
}
exports.default = default_1;
